import { Trans, Translation, useTranslation } from "react-i18next"
import _ from "lodash"

import { PropTypes } from "prop-types"

export const getNamespaceAndId = (ns, fullId) => {
  const [nsNew, idNew] = _.includes(fullId, ":") ? _.split(fullId, ":") : [null, fullId]
  return ns ? [ns, idNew] : [nsNew, idNew]
}

function Translate(props) {
  const { id, data, components, defaults, children, ns } = props

  const [nsNew, idNew] = getNamespaceAndId(ns, id)

  useTranslation(nsNew)
  const namespace = nsNew ? { ns: nsNew } : {}

  if (typeof children === "function") {
    return <Translation {...namespace}>{t => children({ translate: t })}</Translation>
  }

  return (
    <Trans
      {...namespace}
      i18nKey={idNew}
      values={data}
      components={components}
      defaults={defaults}
    />
  )
}

Translate.propTypes = {
  id: PropTypes.string,
  ns: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  components: PropTypes.objectOf(),
  defaults: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
}

export default Translate
